import { Injectable } from "@angular/core";
import { UserService } from "@/_services/user.service";
import { getInstance } from "@features/instance";

@Injectable({ providedIn: "root" })
export class FeatureContextService {
    constructor(private userService: UserService) {
        userService.currentUser$.subscribe((user) => {
            if (!user?.account?._id) {
                return;
            }
            getInstance().setContext({
                accountId: user.account._id,
                isBetaTester: user.account.isBetaTester,
                features: user.account.features ?? [],
            });
        });
    }
}
